import { Directive, Input, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[appMasking]',
    standalone: false
})
export class MaskingDirective implements OnInit, OnDestroy {

  @Input() appMasking: string;
  private $changesSub: Subscription;

  constructor(private el: ElementRef, public ngControl: NgControl) { }

  ngOnInit(): void {

    this.$changesSub = this.ngControl.valueChanges.subscribe(newVal => {

      if (this.appMasking === '(000) 000-0000') {
        this.ngControl.control.setValue(this.onPhoneInputChange(newVal, false), { emitEvent: false });
        // {emitEvent: false} keeps the valueChanges from getting called again if a value needs updated
        this.ngControl.viewToModelUpdate(this.ngControl.control.value);
      } else if (this.appMasking === '00/00/0000') {
        this.ngControl.control.setValue(this.onDateInputChange(newVal, false), { emitEvent: false });
      } else if (this.appMasking === '000-00-0000') {
        this.ngControl.control.setValue(this.onSsnInputChange(newVal, false), { emitEvent: false });
      }

    });

  }

  ngOnDestroy(): void {
    this.$changesSub.unsubscribe();
  }


  onPhoneInputChange(event, backspace) {

    if (event && event.replace) {
      let newVal = event.replace(/\D/g, '');
      if (backspace && newVal.length <= 6) {
        newVal = newVal.substring(0, newVal.length - 1);
      }
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= 3) {
        newVal = newVal.replace(/^(\d{0,3})/, '($1)');
      } else if (newVal.length <= 6) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
      } else if (newVal.length <= 10) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
      } else {
        newVal = newVal.substring(0, 10);
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
      }
      return newVal;
    }
  }

  onSsnInputChange(event, backspace) {
    if (event && event.replace) {
      let newVal = event.replace(/\D/g, '');
      if (backspace && newVal.length <= 12) {
        newVal = newVal.substring(0, newVal.length - 1);
      }

      // Move to Validations...
      // 5.	Cannot begin with:
      // a.	000
      // b.	666
      // c.	900-999
      // 6.	Cannot be 9-repeating numbers
      // a.	EXAMPLE: 222-22-2222
      // 7.	Cannot be a number with consecutive zeros in any digit group
      // a.	EXAMPLE: 000-##-###, ###-00-####, ###-##-0000

      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= 3) {
        newVal = newVal.replace(/^(\d{0,3})/, '$1');
      } else if (newVal.length <= 6) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,2})/, '$1-$2');
      } else if (newVal.length <= 11) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,2})(\d{0,4})/, '$1-$2-$3');
      } else {
        newVal = newVal.substring(0, 12);
        newVal = newVal.replace(/^(\d{0,3})(\d{0,2})(\d{0,4})/, '$1-$2-$3');
      }
      return newVal;
    }
  }

  onDateInputChange(event, backspace) {
    if (event) {
      let newVal = event.replace(/\D/g, '');
      if (backspace && newVal.length <= 6) {
        newVal = newVal.substring(0, newVal.length - 1);
      }
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length === 1) {
        newVal = newVal.replace(/^(\d{0,2})/, '$1');
      } else if (newVal.length === 2) {
        newVal = newVal.replace(/^(\d{0,2})/, '$1/');
      } else if (newVal.length === 3) {
        newVal = newVal.replace(/^(\d{0,2})(\d{0,2})/, '$1/$2');
      } else if (newVal.length === 4) {
        newVal = newVal.replace(/^(\d{0,2})(\d{0,2})/, '$1/$2/');
      } else if (newVal.length <= 8) {
        newVal = newVal.replace(/^(\d{0,2})(\d{0,2})(\d{0,4})/, '$1/$2/$3');
      } else {
        newVal = newVal.substring(0, 8);
        newVal = newVal.replace(/^(\d{0,2})(\d{0,2})(\d{0,4})/, '$1/$2/$3');
      }
      return newVal;
    }
  }

}
